import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const DoomTactile = () => (
  <ArticleWrapper articleId="doom_tactile">
    <div className="prose prose-invert mx-auto p-6">
      <h1>Doom Tactile</h1>
      {/* Add your Doom Tactile article content here */}
      <p>This is a placeholder article for the Doom Tactile switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default DoomTactile;
